import { useCallback, useState } from "react";
import { TimeDTO } from "../interfaces/TimeDTO";
import apiService from "./apiService";
import { HistoricResultDTO } from "../interfaces/HistoricResultDTO";

interface UsehandleHistoricResultsReturn {
    historicResults: HistoricResultDTO[] | null;
    handleHistoricResults: (fiscode: number | null) => void;
}

export function useHistoricEliteResults(
  fiscode?: number | null,

): UsehandleHistoricResultsReturn {
  const [historicResults, setHistoricResults] = useState<HistoricResultDTO[] | null>(null);

  const handleHistoricResults = useCallback(
    async (fiscode?: number | null) => {
      if (!fiscode) {
        setHistoricResults(null);
        return;
      }
      const result:HistoricResultDTO[] | null = await fetchData(fiscode);
      if (result !== null && result !== undefined)
      {
        // Object.keys(result).map((key) => {
        //     console.log(key);
        //     const txt:string[] = key.split(";");
        //     result[key].racename = txt[0];
        //     if (txt.length > 1){
        //         result[key].racedate = txt[txt.length - 1];
        //     }
        //     else{
        //         result[key].racedate = "";
        //     }
        // });
      }
      setHistoricResults(result);
    }, 
    []
  );
  

  const fetchData = async (
    fiscode: number
  ): Promise<HistoricResultDTO[] | null> => {
    try {
        const result = await apiService.get<HistoricResultDTO[]>(
          "GetHistoricResults" +
            "?ApiKey=#apikey#&Fiscode=" + fiscode 
            // +"&TimingProvider=0a9afd9be94c9f567d86fa48c918bcd9"
          // (providerKey ? providerKey : "0a9afd9be94c9f567d86fa48c918bcd9")
        );
        return result;
      } catch (error) {
        return null;
    }
  };

  return { historicResults, handleHistoricResults };
}




